import React, { useEffect, useState } from "react";
import { usersByType } from "../../../../callable-cloud-functions/cloudFunctions";
import DateGeneric from "../../../custom-ui/old-ui/DateGeneric";
import { getUsersWithAffiliations } from "../../../../callable-cloud-functions/cloudFunctions";
import { csvDownload } from "../../AdminMetricDashboard/ExportCsv";
import DownloadIconWithLabel from "../../AdminMetricDashboard/DownLoadIcon";
import { set } from "lodash";

const toArray = (object: any) => {
  const ret = [];
  for (const key in object) {
    const item: any = {};
    const val = object[key];
    item[key] = val;
    ret.push(item);
  }
  return ret;
};

const ALL_AFFILIATION_TYPE = "ALL";

const affiliationValue: any = [
  { name: "Military Spouse", value: "S" },
  { name: "Military Family Member", value: "FM" },
  { name: "Retired", value: "R" },
  { name: "Veteran", value: "V" },
];

const UserByType = () => {
  const [values, setValues] = useState([]);
  const [error, setError] = useState("");
  const [affiliationTypes, setAffilliationTypes] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [affiliationType, setAffiliationType] = useState("");
  const [loadingStates, setLoadingStates] = useState({ loading: false });

  useEffect(() => {
    async function fetchData() {
      try {
        const { data }: any = await usersByType();
        if (data?.affiliationTypes) {
          const arr = toArray(data.affiliationTypes);
          setAffilliationTypes(arr);
        }
        const dataArr = toArray(data);
        setValues(dataArr);
      } catch (err) {
        console.error("Error fetching user types:", err);
        setError("Failed to load user data. Please try again later.");
      }
    }
    fetchData();
  }, []);

  const handleDownload = async (loadingKey: any, fileName: any) => {
    // Reset previous error
    setError("");

    setLoadingStates((prev: any) => ({ ...prev, [loadingKey]: true }));

    try {
      // Validation
      if (!startDate || !endDate) {
        throw new Error("Please select both start and end dates.");
      }

      if (!affiliationType) {
        throw new Error("Please select affiliation type.");
      }

      if (startDate.getTime() >= endDate.getTime()) {
        throw new Error(
          "Please select a valid date range (start date must be before end date)."
        );
      }

      console.log(
        "Downloading data from",
        startDate.getTime(),
        "to",
        endDate.getTime()
      );

      if (affiliationType === ALL_AFFILIATION_TYPE) {
        const responses = await Promise.all(
          affiliationValue.map((option: any) =>
            getUsersWithAffiliations({
              startDate: startDate.getTime(),
              endDate: endDate.getTime(),
              affiliationType: option.value,
            }),
          ),
        );

        const combined: any[] = [];
        responses.forEach((response) => {
          const { data }: any = response?.data || {};
          if (Array.isArray(data) && data.length) {
            combined.push(...data);
          }
        });

        if (!combined.length) {
          throw new Error("No data found in the selected range.");
        }

        csvDownload(combined, "users_with_affiliations_all");
        return;
      }

      const response = await getUsersWithAffiliations({
        startDate: startDate.getTime(),
        endDate: endDate.getTime(),
        affiliationType,
      });

      const { data, fileName: fetchedFileName }: any = response.data || {};

      if (!data || !data.length) {
        throw new Error("No data found in the selected range.");
      }

      csvDownload(data, fetchedFileName || fileName);
    } catch (err: any) {
      console.error("Error during download:", err);
      setError(err?.message || "Something went wrong while downloading the data.");
    } finally {
      setLoadingStates((prev: any) => ({ ...prev, [loadingKey]: false }));
    }
  };

  return (
    <div className="rounded-lg mt-3 bg-white border p-6 bg-card text-card-foreground shadow-sm">
      <div className=" mb-6">
              <p className="text-2xl font-extrabold text-[#1E596D] ">Users by Type</p> 
               <p className="text-lg text-instant-teams-teal-Main">Generate report for users filtered by affiliated type and date range</p>
          </div>
         

      {/* Date Range Picker */}
      <div className="gap-2 grid grid-cols-2">
        <div className="w-full">
          <DateGeneric
            name="startDate"
            display="Start Date"
            value={startDate}
            onChange={setStartDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
        <div className="w-full">
          <DateGeneric
            name="endDate"
            display="End Date"
            value={endDate}
            onChange={setEndDate}
            timestamp={true}
            required
            dateLimit="past"
          />
        </div>
      </div>

      {/* Affiliation Type */}
      <div>
        <h2 className="text-lg mb-1 text-[#1E596D] font-bold">
          Affiliated Type
        </h2>
        <select
          className="border border-[#1E596D] h-12 w-full bg-white rounded-lg p-2 text-[#1E596D]"
          value={affiliationType}
          onChange={(e) => {
            setError("");
            setAffiliationType(e.target.value);
          }}
        >
          <option value="" disabled>
            Select Affiliation Type
          </option>
          <option className="bg-white p-2" value={ALL_AFFILIATION_TYPE}>
            All
          </option>
          {affiliationValue.map((option: any, index: any) => (
            <option className="bg-white p-2" key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>

      {/* Error Message */}
      {error && (
        <div className="">
          <p className="text-red-500 mt-2 text-lg">{error}</p>
        </div>
      )}

      {/* Download Button */}
      <div
        onClick={() => handleDownload("loading", "user_list")}
        className="flex cursor-pointer bg-instant-teams-teal-Main py-3 mt-5 rounded-md text-white justify-center items-center"
      >
        {loadingStates.loading ? (
          <p className="text-lg text-white">Downloading...</p>
        ) : (
          <>
            
            <div className="flex items-start mr-3">
              <DownloadIconWithLabel
                tooltipText="Download users from selected date range and type."
                isFromEmpMetric={true}
                viewDown={true}
              />
                          </div>
                          <p className="text-lg">Download User by Type Report</p>
          </>
        )}
      </div>
    </div>
  );
};

export default UserByType;
